import React from 'react';
import ProductService from '../services/product';
import $ from 'jquery';
import AuthorizationCheck from '../auth/authorizationCheck';
import DatePiCker from 'react-datepicker';
import Utility from '../utilities/utility';
import CountryService from '../services/country';

class PickedProducts extends React.Component {

    constructor(props) {
        super(props);

        this.countryService = new CountryService();

        this.state = {

            productList: [],
            currentUserRole: '',
            timeoutId: null,
            fromDate: '',
            toDate: '',
            countries: [],
        }
    }

    componentDidMount() {

        this.findProducts();
        this.countryList();
        this.setFromDate(new Date());
        this.setToDate(new Date());
    }

    countryList = async () => {

        try {
            const res = await this.countryService.fetchCountries();

            this.setState({
                countries: await res.json()
            });
        } catch (error) {
            console.log(error);
        }

    }

    setFromDate = (date) => {

        this.setState({ fromDate: date })
    }

    setToDate = (date) => {

        this.setState({ toDate: date })
    }

    resetDate = () => {

        this.setFromDate('');
        this.setToDate('');
    }


    findProducts = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();
        let cpid = $('#cpid').val();
        let fromDate = $('#fromDate').val();
        let toDate = $('#toDate').val();
        let countryId = $('#countryId').val();

        if(!Utility.isEmpty(cpid)){

            fromDate = '';
            toDate = '';
        }

        try {

            const response = await ProductService.pickedProductList(name, model, brand, size, color, cpid, fromDate, toDate, countryId);

            if (response.ok) {

                this.setState({
                    productList: await response.json()
                })
            }


        } catch (error) {
            console.log(error);
        }

    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    resetInput = ()=> {

        $('.form-wrapper input').val('');
    }




    render() {



        const productList = this.state.productList;

        const countries = this.state.countries;

        return (


            <div className="container">

                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />





                <div className="supplier-wrapper mt-4">

                    <h2 className="text-center">List de Produits</h2>


                    <div className="form-wrapper">


                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="label">Choisi le Pays</label>
                                    <select className="form-control" id="countryId" onChange={this.findProducts}
                                        onClick={this.resetDate}>
                                        <option></option>
                                        {countries.length > 0 && countries.map(country =>

                                            <option value={country.countryId}>{country.name}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">


                                <div className="form-group">
                                    <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">

                                <div className="form-group">
                                    <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="cpid" placeholder="CPID" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>


                        <div className="row">

                            <div className="col">
                                <div className="form-group">
                                    <DatePiCker id="fromDate" dateFormat="yyyy-MM-dd"
                                        selected={this.state.fromDate} placeholderText="De" className="form-control" 
                                        onChange={(date) => this.setFromDate(date)} />
                                </div>
                            </div>
                            <div className="col">

                                <div className="form-group">
                                    <DatePiCker id="toDate" dateFormat="yyyy-MM-dd"
                                        selected={this.state.toDate} placeholderText="Jusqua" className="form-control" 
                                        onChange={(date) => this.setToDate(date)}/>
                                </div>
                            </div>

                        </div>

                        <button className='btn btn-primary full-width mb-2' onClick={this.findProducts}>Rechercher</button>




                    </div>

                    <div className="card card-default mt-2 bg-primary text-white">



                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">Description</div>
                                <div className="col">Quantité</div>
                                <div className="col">Date</div>
                                <div className="col"></div>


                            </div>
                        </div>

                    </div>

                    {productList.length > 0 && productList.map(product =>

                        <div className="card card-default mt-2" key={product.id}>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4 text-start">
                                        <div>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                        <div className='fw-bold mt-2 border-top border-info'>CPID: {product.supplierUniqueId}</div>
                                        <div className='mt-2'><span className='fw-bold'>Commande: </span> {product.orderDescription}</div>

                                    </div>

                                    <div className="col">{product.quantity}</div>
                                    <div className="col">{product.date}</div>
                                    <div className="col">

                                        <div><a href={'/orderProducts?orderId=' + product.orderId}><button className='btn btn-primary mt-2 btn-sm'>Voir Commande</button></a></div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    )}

                </div>
            </div>



        );


    }
}

export default PickedProducts;